import { observable, action, computed, makeObservable } from "mobx";
export const DataCondition = {
    /** @returns 0 */
    LOADING: 0,
    /** @returns 1 */
    EMPTY: 1,
    /** @returns 2 */
    ERROR: 2,
    /** @returns 3 */
    LOADED: 3,
};
/** Widget condition dependencies */
export const ConditionKeys = ["Marketboard"];
export class Condition {
    constructor(keys) {
        makeObservable(this, {
            set: action,
            value: computed,
        });
        this.dependencies = observable.map(keys.map(k => [k, DataCondition.LOADING]));
    }
    set(key, condition) {
        this.dependencies.set(key, condition);
    }
    get value() {
        return this.resolveCondition();
    }
    /*
    * The order of the condition is important from requirements perspective
    */
    resolveCondition() {
        const dataConditions = [...this.dependencies.values()];
        if (dataConditions.includes(DataCondition.ERROR)) {
            return DataCondition.ERROR;
        }
        if (dataConditions.includes(DataCondition.EMPTY)) {
            return DataCondition.EMPTY;
        }
        if (dataConditions.every(x => x === DataCondition.LOADED)) {
            return DataCondition.LOADED;
        }
        return DataCondition.LOADING;
    }
}
//# sourceMappingURL=Condition.js.map